import cn from 'classnames';
import React, { CSSProperties } from 'react';
import { gtm, selectElement } from 'tracking';
import Button from '../../../../components/button';
import { ISectionCtaFields } from '../../../../global';
import ContentContainer from '../components/content-container';

interface ICtaProps extends ISectionCtaFields {
  id: string;
}

const Cta: React.FC<ICtaProps> = ({
  backgroundColor,
  blank,
  customColorBackground,
  customColorBorder,
  customColorText,
  disableSpacing,
  id,
  link,
  style,
  text,
  textAlignment,
}) => {
  const getButtonStyle = (): CSSProperties => {
    let styleAttrs = {} as CSSProperties;

    if (style === 'Custom Color') {
      styleAttrs.color = customColorText;
      styleAttrs.background = customColorBackground;
      if (customColorBorder) {
        styleAttrs = {
          ...styleAttrs,
          ...{ borderColor: customColorBorder, borderWidth: '2px' },
        };
      }
    }

    return styleAttrs;
  };
  return (
    <ContentContainer
      disableSpacing={disableSpacing}
      backgroundColor={backgroundColor ? backgroundColor : 'white'}
    >
      <div
        className={cn(
          'mx-auto flex w-full max-w-4xl',
          textAlignment &&
            textAlignment === 'Left' &&
            'justify-start text-left',
          textAlignment &&
            textAlignment === 'Center' &&
            'justify-center text-center',
          textAlignment && textAlignment === 'Right' && 'justify-end text-right'
        )}
      >
        <Button
          href={link}
          target={blank && blank === true ? '_blank' : undefined}
          layout={style === 'Orange' ? 'orange' : 'brand'}
          style={getButtonStyle()}
          onClick={() => {
            text && gtm(selectElement({ element: ['Contentful', id, text] }));
          }}
        >
          {text}
        </Button>
      </div>
    </ContentContainer>
  );
};

export default Cta;
